module.exports = __webpack_public_path__ + "static/media/headerJoinPic.f542d494.svg";